import * as React from 'react';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {pushDataLayer} from '../../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../../common/constants/LabelConstants';
import Button from '../../../../../common/components/Button';
import {NotEligibleProps} from '../../../../types/mx/creditoReal/components';
import MotorfyIcon from '../../../../../common/components/MotorfyIcon';

class NotEligibleStepView extends React.Component<NotEligibleProps, {}> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        setTimeout(() => pushDataLayer(DATA_LAYER.DENIED_BUREAU_TURBO_CASH), 200);
    }

    render() {
        return (
            <div className="container">
                <div className="logo-inside-wizard d-none d-sm-block">
                    <MotorfyIcon color="" customClass="navbar-brand-img-lg"/>
                </div>
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="row mb-5 mt-3">
                            <div className="col text-center">
                                <img src={AssetsManager('/assets/images/common/icon-heart-broken.svg')}/>
                            </div>
                        </div>
                        <div className="row mb-3 mt-3">
                            <div className="col text-center">
                                <h3 className="text-raleway text-secondary-lighten-1">
                                    {LOAN_APPLICATION_MX.BUREAU_TITLE_SORRY}
                                </h3>
                            </div>
                        </div>
                        <div className="row p-none mb-3">
                            <div className="col text-center">
                                {LOAN_APPLICATION_MX.BUREAU_SORRY_INVITATION}
                            </div>
                        </div>
                        <div className="row p-none mb-4">
                            <div className="col text-center">
                                {LOAN_APPLICATION_MX.FINISHED_CONTACT_2}
                            </div>
                        </div>
                        <div className="row p-none">
                            <div className="col d-flex justify-content-center">
                                <Button onPress={this.props.onPressGotoHome} text={LOAN_APPLICATION_MX.GOTO_HOME}
                                        customClass="px-5"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotEligibleStepView;